import { render } from "./recurring-overdue.vue?vue&type=template&id=5b276f5e"
import script from "./recurring-overdue.vue?vue&type=script&lang=js"
export * from "./recurring-overdue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__